import { ArticleItem, Stack } from "@tm/components"
import { OE } from "@tm/models"
import { CalcArticle } from "@tm/data/fastCalculator"
import { FastCalculatorOeArticleItemStateProvider } from "./FastCalculatorOeArticleItem"

type Props = {
    oeArticle: OE.OePart
    fastCalculatorArticle: CalcArticle
}
export function FastCalculatorOeItem({ oeArticle, fastCalculatorArticle }: Props) {
    return (
        <Stack width="100%">
            <FastCalculatorOeArticleItemStateProvider article={oeArticle} fastCalculatorArticle={fastCalculatorArticle}>
                <ArticleItem variant="FastCalculatorOe" />
            </FastCalculatorOeArticleItemStateProvider>
        </Stack>
    )
}
